export default function BeardError({ message }) {
    return <div className="push-item push-item__empty">
        <h3>{__('[Beard] Error title')}</h3>
        {message && <p>{message}</p>}
    </div>
}
